import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { platformRoutes } from "./platform/platform.routes";

const appRoutes: Routes = [
    {
        path: "register",
        loadChildren: () => import("app/register/register.module").then((m) => m.AppRegisterModule),
    },
    {
        path: "administration",
        loadChildren: () => import("app/admin/admin-routes").then((m) => m.adminRoutes),
    },
    ...platformRoutes,
    {
        path: "",
        redirectTo: "/login",
        pathMatch: "full",
    },
    {
        path: "**",
        redirectTo: "/login",
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(appRoutes),
    ],
    exports: [
        RouterModule,
    ],
})
export class AppRoutingModule {}
